import { getPromos } from '@/lib/contentstack-sdk';
import { IPromo } from '@/lib/contentstack-sdk/types/component';

/**
 * Returns a list of promos filtered by a studio ID
 * @param studioId - The ID of the design studio
 * @param includeDefaultPromos - Whether to include promos that have no location assigned
 */
export async function getPromosByLocation(
  studioId?: number,
  includeDefaultPromos: boolean = false,
): Promise<IPromo[]> {
  try {
    const allPromos = await getPromos();

    if (!studioId) {
      return allPromos;
    }

    const locationPromos = allPromos.filter((promo) =>
      promo?.design_studios?.location.includes(String(studioId)),
    );

    const defaultPromos = allPromos.filter(
      (promo) => promo?.design_studios?.location.length === 0,
    );

    if (includeDefaultPromos) {
      return [...locationPromos, ...defaultPromos];
    }

    return locationPromos;
  } catch (error) {
    console.error('Error fetching promos by location:', error);
    return [];
  }
}

/**
 * Returns only promos with no studio location assigned
 */
export async function getDefaultPromos(): Promise<IPromo[]> {
  try {
    const allPromos = await getPromos();
    return allPromos.filter(
      (promo) => promo?.design_studios?.location.length === 0,
    );
  } catch (error) {
    console.error('Error fetching default promos:', error);
    return [];
  }
}
